(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const announce = msg => { const n = $('#A11yStatus'); if (!n) return; n.textContent = ''; setTimeout(() => (n.textContent = msg), 50); };
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';

  const menuBtn = $('[data-menu-toggle]');
  const mobileNav = $('#MobileNav');
  const setMenu = open => {
    if (!menuBtn || !mobileNav) return;
    const h = $('.header');
    if (h) document.documentElement.style.setProperty('--header-bottom', h.getBoundingClientRect().bottom + 'px');
    mobileNav.hidden = !open;
    menuBtn.setAttribute('aria-expanded', open);
    menuBtn.querySelector('[data-label]').textContent = open ? menuBtn.dataset.close : menuBtn.dataset.open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { const f = mobileNav.querySelector('a'); f && f.focus(); }
  };
  menuBtn && menuBtn.addEventListener('click', () => setMenu(mobileNav.hidden));

  let lastFocus = null;
  const openDrawer = id => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    const first = d.querySelector('[data-autofocus]') || d.querySelector(FOCUSABLE);
    first && first.focus();
  };
  const closeDrawer = d => {
    d.hidden = true;
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus();
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o && !o.matches('[data-menu-toggle]')) { e.preventDefault(); o.dataset.open === 'CartDrawer' ? refreshCart().then(() => openDrawer('CartDrawer')) : openDrawer(o.dataset.open); return; }
    const c = e.target.closest('[data-close]');
    if (c && !c.matches('[data-menu-toggle]')) closeDrawer(c.closest('.drawer'));
  });
  document.addEventListener('keydown', e => {
    const d = $$('.drawer').find(x => !x.hidden);
    if (e.key === 'Escape') { if (d) closeDrawer(d); else if (mobileNav && !mobileNav.hidden) { setMenu(false); menuBtn.focus(); } }
    if (e.key === 'Tab' && d) {
      const f = $$(FOCUSABLE, d).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  const FMT = String(window.LOWLOW_MONEY || '${{amount}}').replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '').replace(/&amp;/g, '&');
  const money = c => FMT.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
    const n = c / 100;
    if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
    if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  });
  const esc = s => String(s || '').replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  async function refreshCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    $$('[data-cart-count]').forEach(n => (n.textContent = cart.item_count));
    $$('[data-cart-label]').forEach(n => (n.textContent = `Bag, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`));
    const body = $('#CartDrawer [data-cart-body]');
    if (!body) return cart;
    body.innerHTML = cart.items.length
      ? '<ul style="list-style:none;margin:0;padding:0">' + cart.items.map(i => `
        <li class="line-item">
          ${i.image ? `<img src="${esc(i.image)}&width=200" alt="" width="88" height="110" loading="lazy">` : '<span></span>'}
          <div><a href="${esc(i.url)}" style="font-weight:700">${esc(i.product_title)}</a>
            ${i.variant_title ? `<div class="muted">${esc(i.variant_title)}</div>` : ''}
            <div class="muted">Qty ${i.quantity}</div>
            <button class="link-arrow" data-remove="${esc(i.key)}" aria-label="Remove ${esc(i.product_title)} ${esc(i.variant_title || '')}">Remove</button></div>
          <div class="mono">${money(i.final_line_price)}</div>
        </li>`).join('') + '</ul>'
      : '<p class="muted">Your bag is empty.</p>';
    const t = $('#CartDrawer [data-cart-total]'); if (t) t.textContent = money(cart.total_price);
    return cart;
  }
  document.addEventListener('click', async e => {
    const r = e.target.closest('[data-remove]');
    if (!r) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: r.dataset.remove, quantity: 0 }) });
    await refreshCart();
    announce('Item removed from bag.');
    const c = $('#CartDrawer .drawer__close'); c && c.focus();
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]');
    const err = f.querySelector('[data-form-error]');
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
    btn.removeAttribute('aria-busy'); btn.disabled = false;
    if (res.ok) { if (err) err.textContent = ''; await refreshCart(); announce('Added to bag.'); openDrawer('CartDrawer'); }
    else { const j = await res.json().catch(() => ({})); const m = j.description || 'Could not add to bag. Try another size.'; if (err) err.textContent = m; announce(m); }
  });

  $$('[data-variant-picker]').forEach(picker => {
    const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const form = picker.closest('form');
    const idInput = form.querySelector('[name=id]');
    const btn = form.querySelector('[type=submit]');
    const priceEl = $('[data-price]');
    picker.addEventListener('change', () => {
      const chosen = $$('fieldset', picker).map(fs => (fs.querySelector('input:checked') || {}).value);
      $$('fieldset', picker).forEach((fs, i) => { const s = fs.querySelector('[data-selected]'); if (s) s.textContent = chosen[i] || ''; });
      const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; announce('This combination is unavailable.'); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const stock = $('[data-stock]');
      if (stock) {
        const low = +stock.dataset.low;
        if (v.available && v.inv > 0 && v.inv <= low) { stock.textContent = `Only ${v.inv} left`; stock.hidden = false; }
        else { stock.textContent = ''; stock.hidden = true; }
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.sold;
      announce(`${chosen.join(' / ')} selected. ${money(v.price)}. ${v.available ? 'In stock.' : 'Sold out.'}`);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    });
  });

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-pause]');
    if (!b) return;
    const paused = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', paused);
    const label = b.querySelector('[data-label]');
    if (b.dataset.pause === 'marquee') { b.closest('.announce').classList.toggle('is-paused', paused); }
    else { $$('video', b.closest('section')).forEach(v => (paused ? v.pause() : v.play())); }
    if (label) label.textContent = paused ? b.dataset.play : b.dataset.pauseLabel;
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('.announce').forEach(a => a.classList.add('is-paused'));
    $$('[data-pause=marquee]').forEach(b => { b.setAttribute('aria-pressed', 'true'); const l = b.querySelector('[data-label]'); if (l) l.textContent = b.dataset.play; });
    $$('.hero video').forEach(v => v.pause());
  }

  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return el.remove();
    const set = (k, v) => { const n = el.querySelector(`[data-${k}]`); if (n) n.textContent = String(v).padStart(2, '0'); };
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      set('d', Math.floor(s / 86400)); s %= 86400;
      set('h', Math.floor(s / 3600)); s %= 3600;
      set('m', Math.floor(s / 60)); set('s', s % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  $$('[data-size-chart]').forEach(chart => chart.addEventListener('click', e => {
    const b = e.target.closest('[data-unit]');
    if (!b) return;
    $$('[data-unit]', chart).forEach(x => x.setAttribute('aria-pressed', x === b));
    $$('[data-in]', chart).forEach(td => { const v = parseFloat(td.dataset.in); if (!isNaN(v)) td.textContent = b.dataset.unit === 'cm' ? (v * 2.54).toFixed(1) : v; });
    const cap = chart.querySelector('[data-unit-caption]'); if (cap) cap.textContent = b.dataset.unit === 'cm' ? 'centimeters' : 'inches';
    announce(`Showing ${b.dataset.unit === 'cm' ? 'centimeters' : 'inches'}.`);
  }));

  $$('[data-lb]').forEach(wrap => {
    const track = wrap.querySelector('.lookbook');
    wrap.addEventListener('click', e => {
      const b = e.target.closest('[data-dir]'); if (!b) return;
      track.scrollBy({ left: (track.clientWidth * 0.8) * (b.dataset.dir === 'next' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });

  const ok = $('[data-form-success]'); if (ok) { ok.setAttribute('tabindex', '-1'); ok.focus(); }
})();
